import { render, staticRenderFns } from "./PlantSpot.vue?vue&type=template&id=ec075996&scoped=true"
import script from "./PlantSpot.vue?vue&type=script&lang=js"
export * from "./PlantSpot.vue?vue&type=script&lang=js"
import style0 from "./PlantSpot.vue?vue&type=style&index=0&id=ec075996&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec075996",
  null
  
)

export default component.exports